<div fxFlexFill fxLayout="column" class="task-manager">
    <ng-container *ngFor="let video of inprogressVideoList">
      <cmx-card-widget [isFormlyField]="false" [data]="video" *ngIf="video"></cmx-card-widget>
    </ng-container>
</div>
